module.exports = __webpack_public_path__ + "img/dark.530fb77e.svg";